// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.basket-messages {
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin: 5px;
}

.basket-message {
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: flex-start;
    gap: 10px;
    padding: 5px;
    background-color: #f0f0f0;
    border: 3px solid #dddddd;
    border-radius: 6px;
}

.basket-message__image {
    width: 40px;
}

.basket-message__src {
    width: 100%;
    height: auto;
}

.basket-message__body {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.basket-message__title {
    color: var(--color-main);
    font-weight: bold;
    text-align: left;
}

.basket-message__message {
    color: var(--color-blackberry);
    font-weight: normal;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/basket/main.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["\n.basket-messages {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    margin: 5px;\n}\n\n.basket-message {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 5px;\n    background-color: #f0f0f0;\n    border: 3px solid #dddddd;\n    border-radius: 6px;\n}\n\n.basket-message__image {\n    width: 40px;\n}\n\n.basket-message__src {\n    width: 100%;\n    height: auto;\n}\n\n.basket-message__body {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.basket-message__title {\n    color: var(--color-main);\n    font-weight: bold;\n    text-align: left;\n}\n\n.basket-message__message {\n    color: var(--color-blackberry);\n    font-weight: normal;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
